module.exports = __webpack_public_path__ + "static/media/cart-modal-confirm-icon.b82d6b20.svg";